import SignUpVue from '@/views/sa/sign-up/sign-up.vue';

const basePath = '/sa/sign-up';
const role = 'sa'; // 角色身份

export const SA_SIGN_UP_INDEX = 'sa-sign-up';
export const SA_SIGN_UP_SUCCESS = 'sa-sign-up-success';
export const SA_SIGN_UP_FAIL = 'sa-sign-up-fail';

export default {
  path: `${basePath}*`,
  redirect: `${basePath}/index`,
  component: SignUpVue,
  meta: { requiresAuth: true },
  children: [
    {
      path: `${basePath}/index`,
      name: SA_SIGN_UP_INDEX,
      component: () => import(
        /* webpackChunkName: "sign-up" */
        `@/views/${role}/sign-up/index.vue`
      ).catch(() => import('@/views/errors/404.vue')),
      meta: { requiresAuth: true }
    },
    {
      path: `${basePath}/success`,
      name: SA_SIGN_UP_SUCCESS,
      component: () => import(
        /* webpackChunkName: "sign-up-success" */
        `@/views/${role}/sign-up/success.vue`
      ).catch(() => import('@/views/errors/404.vue')),
      meta: { requiresAuth: true }
    },
    {
      path: `${basePath}/fail`,
      name: SA_SIGN_UP_FAIL,
      component: () => import(
        /* webpackChunkName: "sign-up-fail" */
        `@/views/${role}/sign-up/fail.vue`
      ).catch(() => import('@/views/errors/404.vue')),
      meta: { requiresAuth: true }
    }
  ]
};
